import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M17.116 8.446c.71.763 1.134 1.727 1.134 2.776 0 .802-.357 1.642-.896 2.338-1.096 1.417-1.644 2.126-1.738 2.323-.155.329-.113.193-.168.552-.033.216-.012.54.03 1.188l.042.627s-2.234-2.556-2.52-2.556a5.91 5.91 0 0 1-2.8-.688M14.25 7c0 2.9-2.798 5.25-6.25 5.25-.34 0-3 3-3 3l.078-1.17c.05-.741.074-1.111.031-1.352-.064-.359-.039-.288-.214-.608-.117-.214-.671-.817-1.78-2.023C2.312 9.22 1.75 8.08 1.75 7c0-2.9 2.798-5.25 6.25-5.25S14.25 4.1 14.25 7Z"
	})]
});
const ForwardRef = forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
